import { ErrorToast, SuccessToast } from '../../../adminComponents/Toasts/Toasts';

/**
 * Puts a message body on the clipboard, from the hover gutter and the
 * press-and-hold sheet.
 *
 * Not `copyToClipboard` from `helpers/helpers`: that file closes the
 * helpers -> routes -> adminPages cycle documented in `appType.ts`, which
 * renders this whole page as a silent blank. And not bare
 * `navigator.clipboard` either - the async clipboard exists only in secure
 * contexts, and a phone testing against the dev box over plain LAN http
 * (`192.168.x.x:4200`) has no such object. The deprecated textarea path is
 * the only one that works there.
 */
export const copyMessageBody = async (body: string) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(body);
    } else {
      const scratch = document.createElement('textarea');
      scratch.value = body;
      scratch.setAttribute('readonly', '');
      // Parked off screen rather than hidden: display:none is not selectable.
      scratch.style.position = 'fixed';
      scratch.style.top = '-1000px';
      scratch.style.opacity = '0';
      document.body.appendChild(scratch);
      scratch.select();
      document.execCommand('copy');
      scratch.remove();
    }
    SuccessToast('Copied to clipboard');
  } catch {
    ErrorToast('Could not copy the message');
  }
};
